module.exports = __webpack_public_path__ + "static/hauenstein-logo-586e1f2fc7e21faac18d9790f41d63e7.svg";